/* eslint-disable security/detect-object-injection */
/* eslint-disable arrow-body-style */
import { Loader, withModalContext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { JobUtil } from '@xengage/gw-portals-util-js';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { PolicyChangeService, UserService } from 'gw-capability-gateway';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import UnderwritingComponent from 'gw-capability-gateway-react/Components/UnderwritingComponent/UnderwritingComponent';
import gatewayMessages from '../../twiagateway.messages';
import messages from './Summary.messages';
import metadata from './Summary.metadata.json5';
import styles from './Summary.module.scss';

class EndorsementSummary extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string,
        }).isRequired,
        fromAccountLanding: PropTypes.shape({
            quoteDetailsData: PropTypes.shape({
                jobNumber: PropTypes.string.isRequired,
                loadPolicyChangeSummary: PropTypes.shape({}).isRequired,
                updateJobSummary: PropTypes.func.isRequired,
            }),
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
        }).isRequired,
    };

    state = {
        showContinuePolicyChangeButton: false,
        canWithdraw: false,
        isLoading: true,
    };

    componentDidMount() {
        this.canWithdraw();
        this.getShowContinuePolicyChange();
    };

    getShowContinuePolicyChange = async () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'createpolchange',
        };
        const showContinuePolicyChangeButton =
            await UserService.hasUserSystemPermission(
                permissionDTO,
                authHeader
            );

        this.setState({ showContinuePolicyChangeButton, isLoading: false });
    };

    canWithdraw = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadPolicyChangeSummary: policyChange },
            },
        } = this.props;

        if (!_.isEmpty(policyChange)) {
            const translator = this.context;

            if (
                policyChange.status !==
                    translator({
                        id: 'typekey.PolicyPeriodStatus.Bound',
                        defaultMessage: 'Bound',
                    }) &&
                !policyChange.closeDate
            ) {
                this.setState({ canWithdraw: true });
            }
        }
    };

    updateWithDrawPolicyChange = (jobStatusCode, policyChange) => {
        const translator = this.context;
        const status = translator({
            id: `typekey.PolicyPeriodStatus.${jobStatusCode}`,
            defaultMessage: jobStatusCode,
        });

        _.set(policyChange, 'status', status);
        _.set(policyChange, 'statusCode', jobStatusCode);
        this.updateJobSummary(policyChange);
    };

    onContinueTransaction = () => {
        const { lobEndorsementURL } = appConfig;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadPolicyChangeSummary: policyChange },
            },
            history,
            authUserData
        } = this.props;

        const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
        const productCode = _.get(policyChange, 'productCode');
        const isHomeowners = productCode === 'Homeowners';
        const endorsementURL = isTFPA && isHomeowners ? lobEndorsementURL['HomeownersTFPA'] : lobEndorsementURL[productCode];

        if (!_.isEmpty(lobEndorsementURL[productCode])) {
            const redirectLobPath = endorsementURL;

            history.push(redirectLobPath, {
                jobNumber: policyChange.jobNumber,
                policyNumber: policyChange.policy.policyNumber,
                landingFrom: 'quoteSummary',
            });
        } else {
            JobUtil.openJobInXCenter(policyChange.jobNumber);
        }
    };

    onWithdrawTransaction = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadPolicyChangeSummary: policyChange },
            },
            authHeader,
            modalContext,
        } = this.props;

        modalContext
            .showConfirm({
                title: messages.withdrawPolicyChange,
                message: messages.sureWithdrawPolicyChange,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.withdraw,
            })
            .then(result => {
                if (result === 'cancel' || result === 'close') {
                    return;
                }

                PolicyChangeService.withdrawPolicyChangeByPolicyChangeNumber(
                    policyChange.jobNumber,
                    authHeader
                ).then(
                    () => {
                        this.updateWithDrawPolicyChange(
                            'Withdrawn',
                            policyChange
                        );
                    },
                    (e) => { // US26332 - Common Quote - Deactivated Producer Code
                        if (e.appErrorCode === 11001) {
                            modalContext.showAlert({
                                    title: gatewayMessages.modalError,
                                    message: messages.errorDescription,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: commonMessages.cancelModel,
                                }).catch(_.noop);
                        } else {
                            modalContext.showAlert({
                                title: gatewayMessages.modalError,
                                message: messages.failedWithdrawSubmission,
                                status: 'error',
                                icon: 'mi-error-outline',
                                confirmButtonText: commonMessages.ok,
                            }).catch(_.noop);
                        }
                    }
                );
            }, _.noop);
    };

    hasUwIssues = uwIssues => {
        return uwIssues?.filter(uw=>(uw.currentBlockingPoint!=='NonBlocking'
            || (uw.currentBlockingPoint==='NonBlocking' && uw.hasApprovalOrRejection))).length > 0;
    };
    
    showAppropriateBoxesTfpa = (policyChange, isTFPA) => {
        return (this.hasUwIssues(policyChange.underwritingIssues) &&
        policyChange?.underwritingIssues.some(issue =>
            issue.isPolicyHoldTWIA && !issue.hasApprovalOrRejection) && isTFPA);
    }

    getNotificationContent = () => {
        const translator = this.context;
        const { showContinuePolicyChangeButton } = this.state;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadPolicyChangeSummary: policyChange },
            }, authUserData
        } = this.props;
        const content = {};
        const isTFPA = authUserData?.associationName_TWIA === 'tfpa';

        if (
            policyChange &&
            !['Bound', 'Quoted', 'Withdrawn'].includes(
                policyChange.statusCode
            ) &&
            (!this.hasUwIssues(policyChange.underwritingIssues) || (this.showAppropriateBoxesTfpa(policyChange,isTFPA)))
        ) {
            content.infoMessageTitle = !isTFPA ?
                translator(messages.policyChangeStartedTWIA)
                : translator(messages.policyChangeStartedTFPA)
            content.infoMessageDescription = !isTFPA ?
                translator(messages.mayWithdrawOrContinueTWIA)
                : translator(messages.mayWithdrawOrContinueTFPA);
            
        }

        if (
            policyChange &&
            policyChange.statusCode === 'Quoted' &&
            (!this.hasUwIssues(policyChange.underwritingIssues) || (this.showAppropriateBoxesTfpa(policyChange, isTFPA)))
        ) {
            content.infoMessageTitle = isTFPA ? translator(messages.policyChangePremiusCalculated_TFPA) : translator(
                messages.policyChangePremiusCalculated
            );

            let infoMessageDescription;

            if (showContinuePolicyChangeButton) {
                infoMessageDescription = isTFPA
                    ? translator(messages.mayWithdrawOrContinueTFPA)
                    : translator(messages.mayWithdrawOrContinueTWIA);
            } else {
                infoMessageDescription = translator(messages.mayWithDrawPolicyChange);
            }

            content.infoMessageDescription = infoMessageDescription;
        }

        if (policyChange && policyChange.statusCode === 'Bound') {
            content.infoMessageTitle = translator(messages.policyChangeBound);
            content.infoMessageDescription = translator(messages.ChangeBound);
        }

        if (policyChange && policyChange.statusCode === 'Withdrawn') {
            content.infoMessageTitle = translator(messages.policyWithdrawn);
            content.infoMessageDescription = '';
        }

        if (policyChange && policyChange.statusCode === 'Expired') {
            content.infoMessageTitle = translator(messages.expiredMessage);
            content.infoMessageDescription = '';
        }

        return {
            infoMessageTitle: content.infoMessageTitle,
            infoMessageDescription: content.infoMessageDescription,
            withDrawContent: translator(messages.withdrawPolicyChange),
            continueContent: translator(messages.continuePolicyChange),
        };
    };

    getPolicyChangeToProceed = () => {
        const { canWithdraw, showContinuePolicyChangeButton } = this.state;
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadPolicyChangeSummary: policyChange },
            }, authUserData
        } = this.props;
        const isTFPA = authUserData?.associationName_TWIA === 'tfpa';

        if (
            policyChange &&
            (policyChange.statusCode === 'Withdrawn' ||
                policyChange.statusCode === 'Bound')
        ) {
            return {
                isContinueTransaction: false,
                isWithdrawTransaction: false,
            };
        }
        
        if (
            policyChange && isTFPA &&
            (policyChange.statusCode === 'Draft' ||
                policyChange.statusCode === 'Quoted')
        ) {
            return {
                isContinueTransaction: showContinuePolicyChangeButton || true,
                isWithdrawTransaction: showContinuePolicyChangeButton || true,
            };
        }

        return {
            isContinueTransaction:
                showContinuePolicyChangeButton &&
                canWithdraw &&
                !policyChange.isEditLocked,
            isWithdrawTransaction: canWithdraw,
        };
    };

    getPolicyLinkVisible = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadPolicyChangeSummary: policyChange },
            },
        } = this.props;

        const policyNumber = _.get(
            policyChange,
            'policy.latestPeriod.policyNumber',
            'Unassigned'
        );

        return policyNumber !== 'Unassigned';
    };

    redirectToPolicy = () => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadPolicyChangeSummary: policyChange },
            },
        } = this.props;

        const policyNumber = _.get(
            policyChange,
            'policy.latestPeriod.policyNumber'
        );

        return (
            <Link
                to={`/policies/${policyNumber}/summary`}
                className={styles.removeLinkStyle}
            >
                {policyNumber}
            </Link>
        );
    };

    updateJobSummary = policyChange => {
        const {
            fromAccountLanding: {
                quoteDetailsData: { updateJobSummary },
            },
        } = this.props;

        if (updateJobSummary) {
            updateJobSummary(policyChange);
        }
    };

    render() {
        const {
            fromAccountLanding: {
                quoteDetailsData: { loadPolicyChangeSummary: policyChange },
            },authUserData
        } = this.props;
        const { isLoading } = this.state;

        if (_.isEmpty(policyChange)) {
            return <Loader loaded={!isLoading} />;
        }

        const totalPremiumInclTaxesandFees = () => {
            let totalPremiumAmount = _.get(policyChange, 'policy.latestPeriod.totalPremium.amount');

            if (policyChange.status !== 'Bound') {
                const latestPeriod = _.find(_.get(policyChange, 'policy.periods'), (item) => {
                    return item.jobType_TWIA === 'PolicyChange' && policyChange.status === item.status && policyChange.jobNumber === item.jobNumber_TWIA;
                });
                if (!_.isEmpty(latestPeriod) && _.get(latestPeriod, 'totalPremium.amount')) {
                    totalPremiumAmount =  _.get(latestPeriod, 'totalPremium.amount');
                }
            }

            return {
                currency: 'usd',
                amount: totalPremiumAmount
            };
        };
        
        // DE18493
        const totalCostInclAssSurCharge = () => {
            const totalCostAmount = _.get(policyChange, 'policy.latestPeriod.totalCost.amount');
            const AssSurChargeAmount = _.get(policyChange, 'policy.latestPeriod.totalAssociationSurcharge_TWIA.amount');

            let totalAmount = totalCostAmount + AssSurChargeAmount;            

            if (policyChange.status !== 'Bound') {
                const latestPeriod = _.find(_.get(policyChange, 'policy.periods'), (item) => {
                    return item.jobType_TWIA === 'PolicyChange' && policyChange.status === item.status && policyChange.jobNumber === item.jobNumber_TWIA;
                });
                if (!_.isEmpty(latestPeriod) && _.get(latestPeriod, 'totalCost.amount')) {
                    totalAmount =  _.get(latestPeriod, 'totalCost.amount') + _.get(latestPeriod, 'totalAssociationSurcharge_TWIA.amount');
                }
            }

            return {
                currency: 'usd',
                amount: totalAmount
            };
        };

        const associationName = _.get(authUserData, 'associationName_TWIA');
        const isTFPA = associationName === 'tfpa';
        const statusCode = _.get(policyChange, 'statusCode')
        const quotedState = ['Quoted',  'NotTaken', 'Withdrawn', 'Expired', 'Submitted_Ext', 'Bound'].includes(statusCode); // DE18444

        const overrides = {
            '@field': {
                readOnly: true,
            },
            quoteNotification: {
                notificationContent: this.getNotificationContent(),
                transactionVisibleActions: this.getPolicyChangeToProceed(),
            },
            underwritingTable: {
                job: policyChange,
                isTFPA,
                continueJob: this.getPolicyChangeToProceed(),
                jobService: PolicyChangeService,
                onUpdateJobSummary: this.updateJobSummary,
            },
            policyInfoLink: {
                visible: this.getPolicyLinkVisible(),
                value: this.redirectToPolicy(),
            },
            quotedBoundContainer: {
                visible: quotedState
            },
            totalPremiumTwia: {
                value:  totalPremiumInclTaxesandFees(),
                visible: quotedState && associationName === "twia"
            },
            totalAssociationSurcharge: {
                visible: quotedState && associationName === "twia" &&
                    _.get(policyChange, 'policy.latestPeriod.totalAssociationSurcharge_TWIA.amount') > 0
            },
            totalAssociationSeparator: {
                visible: quotedState && associationName === "twia" &&
                    _.get(policyChange, 'policy.latestPeriod.totalAssociationSurcharge_TWIA.amount') > 0
            },
            totalPremiumTfpa: {
                visible: quotedState && associationName !== "twia"
            },
            taxesAndFeesId: {
                visible: quotedState && associationName !== "twia"
            },
            quotedCostSeparator: {
                visible: quotedState && associationName !== "twia"
            },
            totalCostIdTwia: {
                value: totalCostInclAssSurCharge(), // DE18493
                visible: quotedState && associationName === "twia"
            },
            totalCostIdTfpa: {
                visible: quotedState && associationName !== "twia"
            },
            producerCodeOfRecordOrgId: {
                value: `${_.get(
                    policyChange,
                    'policy.latestPeriod.producerCodeOfRecordOrg'
                )} (${_.get(
                    policyChange,
                    'policy.latestPeriod.producerCodeOfRecord'
                )})`,
            },
            producerOfServiceId: {
                value: `${_.get(
                    policyChange,
                    'policy.latestPeriod.producerCodeOfServiceOrg'
                )} (${_.get(
                    policyChange,
                    'policy.latestPeriod.producerCodeOfService'
                )})`,
            },
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                underwritingcomponent: UnderwritingComponent,
            },
            resolveCallbackMap: {
                onContinueTransaction: this.onContinueTransaction,
                onWithdrawTransaction: this.onWithdrawTransaction,
            },
        };
        const readValue = (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                policyChange,
                id,
                path,
                overrides
            );
        };

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={policyChange}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                resolveValue={readValue}
            />
        );
    }
}

export default withAuthenticationContext(withModalContext(EndorsementSummary));
